// 路由工具函数
import router from '@/router'

// 支持的语言列表
const SUPPORTED_LANGUAGES = ['zh', 'en', 'ja', 'ko', 'ru', 'es', 'fr', 'ar']

// 获取当前语言
export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'en'
}

// 从路径中提取语言
export const extractLanguageFromPath = (path) => {
  const segments = path.split('/').filter(segment => segment)
  if (segments.length > 0 && SUPPORTED_LANGUAGES.includes(segments[0])) {
    return segments[0]
  }
  return null
}

// 获取不带语言前缀的路径
export const getPathWithoutLanguage = (path) => {
  const segments = path.split('/').filter(segment => segment)
  if (segments.length > 0 && SUPPORTED_LANGUAGES.includes(segments[0])) {
    return '/' + segments.slice(1).join('/')
  }
  return path
}

// 生成带语言前缀的路径
export const generateLanguagePath = (path, language = null) => {
  const currentLang = language || getCurrentLanguage()
  const cleanPath = getPathWithoutLanguage(path)
  return `/${currentLang}${cleanPath}`
}

// 多语言路由跳转
export const pushWithLanguage = (to, language = null, query = null) => {
  const currentLang = language || getCurrentLanguage()
  const targetPath = generateLanguagePath(to, currentLang)
  
  if (query) {
    return router.push({
      path: targetPath,
      query: query
    })
  }
  
  return router.push(targetPath)
}

// 多语言路由替换
export const replaceWithLanguage = (to, language = null, query = null) => {
  const currentLang = language || getCurrentLanguage()
  const targetPath = generateLanguagePath(to, currentLang)
  
  if (query) {
    return router.replace({
      path: targetPath,
      query: query
    })
  }
  
  return router.replace(targetPath)
}

// 切换语言并跳转
export const switchLanguage = (newLanguage, currentPath = null) => {
  const path = currentPath || router.currentRoute.path
  const cleanPath = getPathWithoutLanguage(path)
  const newPath = generateLanguagePath(cleanPath, newLanguage)
  
  // 更新语言设置
  localStorage.setItem('language', newLanguage)
  
  // 跳转到新路径
  return router.push(newPath)
} 